import {call, put, takeLatest} from "redux-saga/effects";
import {authActions} from "../actions/authActions";
import {ActionTypesSaga} from "../actions/SagaActions";
import {user_getMyInfo} from "../../../network/api/user.api";
import {configs_getWebAppSplash} from "../../../network/api/configs.api";
import {settingActions} from "../actions/SettingsActions";
import {invoiceActions} from "../actions/InvoiceActions";
import {invoice_query} from "../../../network/api/invoice.api";


export function* saga() {
    yield takeLatest(ActionTypesSaga.RequestUser, function* userRequested() {
        try {
            const res = yield call(user_getMyInfo);
            const data = res?.data?.Data;
            const status = data?.UserStatus || data?.userStatus;
            if (status && status !== "ENABLED") {
                yield put(authActions.Logout());
            } else {
                yield put(authActions.SetUser(data));
                if (data?.Id) {
                    try {
                        const settingsRes = yield call(configs_getWebAppSplash, { UserId: data.Id });
                        const settingsData = settingsRes?.data?.Data;
                        if (settingsData) {
                            yield put(settingActions.SetServerSettings(settingsData));
                        }
                    } catch (err) {
                        console.error("Saga splash fetch error:", err);
                    }
                }
            }
        } catch (e) {
            console.error("Saga RequestUser error:", e);
        }
    });

    yield takeLatest(ActionTypesSaga.RequestServerSettings, function* settingRequested(action) {
        try {
            const userId = action?.payload?.user?.Id;
            if (!userId) return;
            const res = yield call(configs_getWebAppSplash, { UserId: userId });
            const data = res?.data?.Data;
            if (data) {
                yield put(settingActions.SetServerSettings(data));
            }
        } catch (e) {
            console.error("Saga RequestServerSettings error:", e);
        }
    });

    yield takeLatest(ActionTypesSaga.RequestUserInvoices, function* InvoicesRequested(action) {
        try {
            const userId = action?.payload?.user?.Id;
            if (!userId) return;
            const res = yield call(invoice_query, {
                queryType: "FILTER",
                UserId: userId,
                paging: { Page: 0, Size: 100 }
            });
            const content = res?.data?.Data?.content;
            if (content) {
                yield put(invoiceActions.SetInvoices(content.filter(i => i.Status !== "DRAFT")));
                yield put(invoiceActions.SetUserBasket(content.find(i => i.Status === "DRAFT") || null));
            }
        } catch (e) {
            console.error("Saga RequestUserInvoices error:", e);
        }
    });

    yield takeLatest(ActionTypesSaga.RequestLogout, function* logoutRequested() {
        try {
            yield put(settingActions.SetServerSettings(undefined));
            yield put(settingActions.SetAppSettings(undefined));
            yield put(invoiceActions.SetInvoices(undefined));
            yield put(invoiceActions.SetUserBasket(undefined));
            yield put(authActions.Logout());
        } catch (e) {
            console.error("Saga RequestLogout error:", e);
        }
    });
}
